import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td} from "@chakra-ui/react";
import { DateFilter, TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useMemo, useCallback, useRef} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom,modalAtom } from "../../../context";
import { NewLoader as Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { MdMoreVert as MoreIcon } from "react-icons/md"
import moment from "moment";
import ReactSelect from "../../../components/Select";
import appStore, { activePeriod } from "../../../store";
import {
  Grid,
  GridItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'


const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`



// Custom debounce function
function debounce(func: (...args: any[]) => any, wait: number): (...args: any[]) => void {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  return function(this: any, ...args: any[]): void {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

export default function RegistrationReport({ data }: any) {
  const [hide, set_hide] = useState<boolean>(true);
  const queryClient = useQueryClient();
  const [activeIndex] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const aPeriod = appStore.get(activePeriod)?.Id;
  const [, set_notification] = useAtom(notificationAtom);

  // ---------- Server-side filters / UI state ----------
  const [selected_examperiod, set_selected_examperiod] = useState<number | null>(aPeriod ?? null);
  const [selected_level, set_selected_level] = useState<number | null>(null); // LevelId
  const [selected_resit, set_selected_resit] = useState<string | null>(null); // ResitPrompt (server-side)

  // Search (client-side across ALL fetched rows)
  const [searchInput, setSearchInput] = useState<string>("");

  // Pagination (client-side)
  const [currentPage, setCurrentPage] = useState<number>(0); // 0-based
  const itemsPerPage = 100; // fixed page size per Option 1

  // Small debounce for search input to avoid rapid re-renders (200ms)
  const searchDebounceRef = useRef<number | null>(null);

  // ---------- Static lists (safe normalization) ----------
  // const { data: allExamPeriodRaw = [], isLoading: loadingPeriods } = useQuery(
  //   ["exam-period"],
  //   async () => {
  //     const res = await apiCall().get(`/SetUp/GetAllExamPeriod`);
  //     return Array.isArray(res.data?.Data) ? res.data.Data : [];
  //   },
  //   { staleTime: 5 * 60 * 1000 }
  // );

    const { data: allExamPeriodRaw = [], isLoading: loadingPeriods } = useQuery(['exam-period'], {
    queryFn: async () => await apiCall().get(`exam/setup/examPeriod`),
    select(data) {
      return [{ Id: null, ExamName: 'All Periods' }, ...data.data.Data];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  });

  // const { data: allLevelsRaw = [], isLoading: loadingLevels } = useQuery(
  //   ["exemption"],
  //   async () => {
  //     const res = await apiCall().get(`/SetUp/GetAllExemption`);
  //     return Array.isArray(res.data?.Data) ? res.data.Data : Array.isArray(res.data) ? res.data : [];
  //   },
  //   { staleTime: 5 * 60 * 1000 }
  // );

    const { data: allLevelsRaw = [], isLoading: loadingLevels  } = useQuery(['exemption'], {
    queryFn: async () => await apiCall().get(`/setup/GetAllExemption`),
    select(data) {
      return data.data.Data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  });

  // Normalize option lists
  const allExamPeriod = Array.isArray(allExamPeriodRaw) ? allExamPeriodRaw : [];
  const allLevels = Array.isArray(allLevelsRaw) ? allLevelsRaw : [];

  // ---------- Fetch ALL rows for selected filters (server-side filter, client-side search/pagination) ----------
  // Strategy:
  // 1) Fetch first page with a reasonable pageSize to get TotalCount & PageCount
  // 2) If more pages exist, fetch remaining pages in parallel in batches
  const fetchAllCandidates = async (
    examPeriodId: number | null,
    levelId: number | null,
    resitPrompt: string | null
  ) => {
    const pageSizeFetch = 1000; // chunk size for server fetch - adjust if needed
    const paramsFirst: any = { PageNumber: 1, PageSize: pageSizeFetch };
    if (examPeriodId) paramsFirst.ExamPeriodId = examPeriodId;
    if (levelId) paramsFirst.LevelId = levelId;
    if (resitPrompt) paramsFirst.ResitPrompt = resitPrompt;

    const firstResp = await apiCall().get(`ExamReport/candidateRegistrationReport`, { params: paramsFirst });
    const firstData = firstResp.data ?? {};
    const firstItems = firstData.reportItems ?? firstData.Data ?? [];
    const totalCount = firstData.TotalCount ?? firstData.TotalSize ?? firstItems.length;
    const pageCount = firstData.PageCount ?? Math.max(1, Math.ceil(totalCount / pageSizeFetch));

    // If only one page, return the firstItems
    if (pageCount <= 1) {
      return Array.isArray(firstItems) ? firstItems : [];
    }

    // Build remaining page fetches (2..pageCount)
    const remainingPages = [];
    for (let p = 2; p <= pageCount; p++) remainingPages.push(p);

    // Fetch remaining pages in batches to avoid too many parallel requests
    const batchSize = 5;
    const results: any[] = [...(Array.isArray(firstItems) ? firstItems : [])];

    for (let i = 0; i < remainingPages.length; i += batchSize) {
      const batch = remainingPages.slice(i, i + batchSize);
      const promises = batch.map((pg) => {
        const params = { PageNumber: pg, PageSize: pageSizeFetch } as any;
        if (examPeriodId) params.ExamPeriodId = examPeriodId;
        if (levelId) params.LevelId = levelId;
        if (resitPrompt) params.ResitPrompt = resitPrompt;
        return apiCall().get(`ExamReport/candidateRegistrationReport`, { params }).then((r) => r.data ?? {});
      });

      const settled = await Promise.allSettled(promises);
      settled.forEach((s) => {
        if (s.status === "fulfilled") {
          const payload = s.value ?? {};
          const arr = payload.reportItems ?? payload.Data ?? [];
          if (Array.isArray(arr)) results.push(...arr);
        }
      });
    }

    return results;
  };

  // React Query to fetch all rows whenever server filters change
  const {
    data: allItems = [],
    isLoading: isLoadingAll,
    isFetching: isFetchingAll,
    refetch: refetchAll,
  } = useQuery(
    ["registration-all", selected_examperiod, selected_level, selected_resit],
    () => fetchAllCandidates(selected_examperiod, selected_level, selected_resit),
    {
      keepPreviousData: false,
      staleTime: 1000 * 60 * 2, // cache for 2 minutes
      retry: 1,
      onError: (err) => console.error("Error fetching all candidates:", err),
    }
  );

  const allItemsArray = Array.isArray(allItems) ? allItems : [];

  // ---------- Client-side search over allItems (StudentNo primary, then Name) ----------
  // Debounce search input to avoid instant re-filter on every keystroke, small delay
  useEffect(() => {
    if (searchDebounceRef.current) {
      window.clearTimeout(searchDebounceRef.current);
      searchDebounceRef.current = null;
    }
    searchDebounceRef.current = window.setTimeout(() => {
      // Reset page to first on search per Option A
      setCurrentPage(0);
      // No server search at all — purely client-side
    }, 150);

    return () => {
      if (searchDebounceRef.current) {
        window.clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = null;
      }
    };
  }, [searchInput]);

  // Filtered data is memoized for performance
  const filteredData = useMemo(() => {
    const q = (searchInput ?? "").trim().toLowerCase();
    if (!q) return allItemsArray;

    // Primary: StudentNo match
    const byStudentNo = allItemsArray.filter((r: any) => {
      const studentNo = String(r?.StudentNumber ?? r?.StudentNo ?? r?.ExamNumber ?? "").toLowerCase();
      return studentNo.includes(q);
    });

    if (byStudentNo.length > 0) return byStudentNo;

    // Secondary: Name match (Surname + Othernames / FirstName LastName)
    const byName = allItemsArray.filter((r: any) => {
      const names = `${r?.Surname ?? ""} ${r?.Othernames ?? ""} ${r?.FirstName ?? ""} ${r?.LastName ?? ""}`.toLowerCase();
      return names.includes(q);
    });

    return byName;
  }, [allItemsArray, searchInput]);

  // ---------- Pagination (client-side based on filteredData) ----------
  const pageCount = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));

  // Ensure currentPage valid whenever filteredData or pageCount changes
  useEffect(() => {
    if (currentPage >= pageCount) {
      setCurrentPage(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageCount]);

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedItems = filteredData.slice(startIndex, endIndex);

  // Derived UI numbers
  const showingFrom = filteredData.length > 0 ? startIndex + 1 : 0;
  const showingTo = filteredData.length > 0 ? Math.min(endIndex, filteredData.length) : 0;
  const totalCount = filteredData.length;

  // ---------- Handlers ----------
  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
  };

  const handleFilterChange = (value: any, type: "period" | "level" | "resit") => {
    if (type === "period") set_selected_examperiod(value ? Number(value) : null);
    if (type === "level") set_selected_level(value ? Number(value) : null);
    if (type === "resit") set_selected_resit(value ? String(value) : null);
    // When server filter changes we must refetch all items
    setCurrentPage(0);
    // react-query key will trigger fetch automatically
  };

  const handlePageClick = (event: any) => {
    const selected = event.selected;
    if (selected >= pageCount) {
      setCurrentPage(0);
      return;
    }
    setCurrentPage(selected);
  };

  const handleReset = () => {
    set_selected_examperiod(aPeriod ?? null);
    set_selected_level(null);
    set_selected_resit(null);
    setSearchInput("");
    setCurrentPage(0);
    refetchAll();
  };

 const { mutate: handleDownload, isLoading: isDownloading } = useMutation({
  mutationKey: ["download-candidate-registration-report", selected_examperiod, selected_level, selected_resit],
  mutationFn: async () => {
    const params: any = {};
    params.PageNumber = 1;
    params.PageSize = filteredData.length || 1; 
    if (selected_examperiod) params.ExamPeriodId = selected_examperiod;
    if (selected_level) params.LevelId = selected_level;
    if (selected_resit) params.ResitPrompt = selected_resit;

    const query = new URLSearchParams(params).toString();
    const url = `/ExamReport/downloadCandidateRegistrationReport?${query}`;

    return await apiCall().post(url, {}, { responseType: "blob" });
  },
 onSuccess: (res: any) => {
  const fileUrl = window.URL.createObjectURL(res.data); // ✅ FIXED
  const link = document.createElement("a");
  link.href = fileUrl;
  link.setAttribute("download", "Registered-Candidate-Report.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  set_notification({ type: "success", message: "Download successful" });
  set_Nopen(true);
},
  onError: (err: any) => {
    set_notification({ type: "error", message: err?.message || "Download failed" });
    set_Nopen(true);
  },
  onSettled: () => set_open(false),
});


  // ---------- UI ----------
  return (
    <>
      <Box>
        <TopDisplay
          label="Registered Candidate Report"
          button_array={[
            <Button
              disabled={isDownloading}
              type="button"
              color="var(--white-color)"
              bg="var(--dark-green-color)"
              leftIcon={<DownloadIcon />}
              onClick={() => handleDownload()}
            >
              {isDownloading ? "Downloading..." : "Download Registered Candidate Report"}
            </Button>,
          ]}
        />

        <Flex gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents="none"><SearchIcon color="gray.300" /></InputLeftElement>
            <Input
              value={searchInput}
              onChange={onSearchChange}
              type="text"
              placeholder="Search StudentNo or Names"
            />
            <span
              style={{ position: 'absolute', zIndex: 1, right: 10, cursor: 'pointer', top: 12 }}
              onClick={handleReset}
              title="Reset Filters"
            >
              <ReloadIcon />
            </span>
          </InputGroup>

          <Select
            placeholder="Exam Period"
            width="180px"
            bg="var(--white-color)"
            borderColor="var(--dark-green-color)"
            value={selected_examperiod ?? ""}
            onChange={(e: any) => handleFilterChange(e.target.value, "period")}
          >
            <option value="">All Periods</option>
            {Array.isArray(allExamPeriod) && allExamPeriod.map((p: any) => (
              <option key={p.Id} value={p.Id}>
                {p.ExamName}
              </option>
            ))}
          </Select>

          <Select
            placeholder="Level"
            width="160px"
            bg="var(--white-color)"
            borderColor="var(--dark-green-color)"
            value={selected_level ?? ""}
            onChange={(e: any) => handleFilterChange(e.target.value, "level")}
          >
            <option value="">All Levels</option>
            {Array.isArray(allLevels) && allLevels.map((lvl: any) => (
              <option key={lvl.Id} value={lvl.Id}>{lvl.Name}</option>
            ))}
          </Select>

          <Select
            placeholder="Re-Sit Type"
            width="120px"
            bg="var(--white-color)"
            borderColor="var(--dark-green-color)"
            value={selected_resit ?? ""}
            onChange={(e: any) => handleFilterChange(e.target.value, "resit")}
          >
            <option value="">All</option>
            <option value="Both">Both</option>
            <option value="Resit">Resit</option>
            <option value="Regular">Regular</option>
          </Select>

          <Button onClick={handleReset} color="white" bg="green">Reset Filters</Button>
        </Flex>

        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Registered Candidate Report</Heading>
          <Text m="0" fontSize=".8rem">
            Showing {showingFrom} - {showingTo} of {totalCount}
            {(isLoadingAll || isFetchingAll || loadingPeriods || loadingLevels) ? " (loading...)" : ""}
          </Text>
        </Flex>

        { (isLoadingAll || loadingPeriods || loadingLevels) ? (
          <Loader show />
        ) : (
          displayedItems && displayedItems.length > 0 ? (
            <TableContainer mt="20px">
              <Table size="sm" variant="striped" sx={{ tableLayout: 'auto', width: '100%' }}>
                <Thead>
                  <Tr>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Title</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Exam Number</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '120px' }}>Surname</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Other Names</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '130px' }}>Student Number</Th>
                    <Th sx={{ ...DataStyle, p: 2, minWidth: '120px' }}>Phone No</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '150px' }}>Email</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Address</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam-Diet</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Resit</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Exam-Fee</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Current/Sub</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '180px' }}>Registered/Sub</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '100px' }}>Last Exam</Th>
                    <Th sx={{ ...HeadStyle, p: 2, minWidth: '50px' }}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {displayedItems.map((eUpgradeScore: any, index: number) => (
                    <ROWSTYLE key={eUpgradeScore.Id ?? eUpgradeScore.StudentNumber ?? index}>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Title || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.ExamNumber || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Surname || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2, whiteSpace: 'normal' }}>{eUpgradeScore.Othernames || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.StudentNumber || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.PhoneNumber || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Email || 'N/A'}</Td>
                      <Td title={eUpgradeScore.Address} sx={{ ...DataStyle, p: 2, whiteSpace: 'normal', maxWidth: '180px' }}>{eUpgradeScore.Address || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.ExamDiet || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.Resit || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.ExamFee || 'N/A'}</Td>
                      <Td title={eUpgradeScore.CurrentRegisteredSubjects} sx={{ ...DataStyle, p: 2, whiteSpace: 'normal', maxWidth: '180px' }}>{eUpgradeScore.CurrentRegisteredSubjects || 'N/A'}</Td>
                      <Td title={eUpgradeScore.RegisteredSubjects} sx={{ ...DataStyle, p: 2, whiteSpace: 'normal', maxWidth: '180px' }}>{eUpgradeScore.RegisteredSubjects || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }}>{eUpgradeScore.LastLevel || 'N/A'}</Td>
                      <Td sx={{ ...DataStyle, p: 2 }} w="50px">
                        <div className={activeIndex === index ? 'active' : ''}><Option {...{ index, candidate: eUpgradeScore }} /></div>
                      </Td>
                    </ROWSTYLE>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <Text mt="20px">No Registered Candidate</Text>
          )
        )}

        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            forcePage={currentPage}
            renderOnZeroPageCount={null}
          />
        </StylePaginateBox>
      </Box>

      {(isLoadingAll || loadingPeriods || loadingLevels) && <Loader show />}
    </>
  );
}







const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
  const queryClient = useQueryClient();

  // useEffect(()=>{
  //   set_new_level(candidate?.Level?.Id)
  // },[])

 

  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }

 
  
  // useEffect(()=>{
  //   return ()=>set_index(null)
  // },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>
            View Details
          </GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}

const ViewProfile = (props:any) =>{
  // const img = "/public-assets/profile.png";
  return(
  <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
    <Grid templateColumns="1fr"  gap="30px">
      
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Student No</Text>
        <Text fontWeight="500">{props.candidate?.StudentNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">SurName</Text>
        <Text fontWeight="500">
          {props.candidate.Surname}
        </Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Other Names</Text>
        <Text fontWeight="500">{props.candidate?.Othernames}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Last Level</Text>
        <Text fontWeight="500">{props.candidate?.LastLevel}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Exam Number</Text>
        <Text fontWeight="500">{props.candidate?.ExamNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Phone Number</Text>
        <Text fontWeight="500">{props.candidate?.PhoneNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Email</Text>
        <Text fontWeight="500">{props.candidate?.Email}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Address</Text>
        <Text fontWeight="500">{props.candidate?.Address}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Current Subjects</Text>
        <Text fontWeight="500" style={{width:'100%',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'wrap'}}>{props.candidate.CurrentRegisteredSubjects}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Registered Subjects</Text>
        <Text fontWeight="500" style={{width:'100%',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'wrap'}}>{props.candidate.RegisteredSubjects}</Text>
      </GridItem>
    </Grid>
  </Flex>
  )}
